function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Components, endpoints } from 'shared/helper/file';
import { FILE_TYPE_FIGURE, FILE_TYPE_MANUSCRIPT, FILE_TYPE_TABLE } from '../constants';
import RequireServiceDetails from './RequireServiceDetailsContainer';
var Manuscripts = Components.Manuscripts,
  Figures = Components.Figures,
  Tables = Components.Tables;
var fileTypeToComponentMap = _defineProperty(_defineProperty(_defineProperty({}, FILE_TYPE_MANUSCRIPT, Manuscripts), FILE_TYPE_FIGURE, Figures), FILE_TYPE_TABLE, Tables);
var Files = function Files(_ref) {
  var alertsForTypes = _ref.alertsForTypes,
    children = _ref.children,
    disabled = _ref.disabled,
    excludedFileTypes = _ref.excludedFileTypes,
    fileTypes = _ref.fileTypes,
    serviceIdentities = _ref.serviceIdentities,
    methods = _ref.methods;
  return /*#__PURE__*/React.createElement(RequireServiceDetails, {
    loadingComponent: function loadingComponent() {
      return /*#__PURE__*/React.createElement("div", null, children);
    },
    serviceIdentities: serviceIdentities
  }, fileTypes.filter(function (fileType) {
    return excludedFileTypes.indexOf(fileType) === -1;
  }).map(function (fileType) {
    var FileComponent = fileTypeToComponentMap[fileType];
    return /*#__PURE__*/React.createElement(FileComponent, {
      apiRoot: endpoints.researcher,
      methods: methods,
      alertMessage: alertsForTypes[fileType] || null,
      disabled: disabled,
      key: fileType
    });
  }));
};
export default Files;